import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icons in Leaflet with webpack/vite
// @ts-ignore
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

interface MapViewProps {
  latitude: number;
  longitude: number;
  address?: string;
  zoom?: number;
  height?: string;
}

export default function MapView({ 
  latitude, 
  longitude, 
  address, 
  zoom = 15,
  height = 'h-96'
}: MapViewProps) {
  // Coordonnées par défaut (Songon, Abidjan, Côte d'Ivoire)
  const lat = latitude || 5.31666700;
  const lng = longitude || -4.03333300;

  return (
    <div className={`w-full ${height} rounded-lg overflow-hidden shadow-md`}>
      <MapContainer
        center={[lat, lng]}
        zoom={zoom}
        scrollWheelZoom={true}
        style={{ height: '100%', width: '100%' }}
        className="z-0"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[lat, lng]}>
          <Popup>
            {address ? (
              <div className="text-sm">
                <strong className="block mb-1">{address}</strong>
                <span className="text-gray-600">
                  📍 {lat.toFixed(6)}, {lng.toFixed(6)}
                </span>
              </div>
            ) : (
              <div className="text-sm">
                <span className="text-gray-600">
                  📍 {lat.toFixed(6)}, {lng.toFixed(6)}
                </span>
              </div>
            )}
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
}

